import {ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ToastrService} from 'ngx-toastr';
import {finalize, lastValueFrom} from 'rxjs';
import {AgendaService} from 'src/app/api/module/erp/services/area-logada/agenda/agenda.service';
import {ModuloPermissoesService} from 'src/app/api/module/erp/services/area-logada/modulo-permissoes/modulo-permissoes.service';
import {Modulo} from 'src/app/api/module/erp/shared/enumerable/modulos';
import {PropostaExternaEnum} from 'src/app/api/module/erp/shared/enumerable/poposta-externa.enum';
import {SubModuloNome} from 'src/app/api/module/erp/shared/enumerable/submodulos';
import {CompartilharDadosEntreComponentsService} from 'src/app/api/module/erp/shared/services/compartilhar-dados-entre-components.service';
import {ErrorLoggingService} from 'src/app/api/module/erp/shared/services/error-logs/error-logging.service';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {TipoPropostaEnum} from './../../../../../api/module/erp/shared/enumerable/tipo-poposta.enum';

@Component({
  selector: 'app-proposta-entidade-videoconferencia',
  templateUrl: './proposta-entidade-videoconferencia.component.html',
  styleUrls: ['./proposta-entidade-videoconferencia.component.scss'],
})
export class PropostaEntidadeVideoconferenciaComponent implements OnInit {
  @ViewChild('templateModalApagar') templateModalApagar!: TemplateRef<any>;
  @ViewChild('templateModalAgendarMeet')
  templateModalAgendarMeet!: TemplateRef<any>;

  mensagemSessao: string = 'Sessão vencida, faça o login';
  diasDaSemana = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];
  listaSemana: any[] = [];
  hoje = new Date();
  dataSelecionadaAtual: string = '';
  semanaOffset = 0; // 0 = semana atual, 1 = próxima semana, etc.
  listaHorariosManha: any[] = [];
  listaHorariosTarde: any[] = [];
  modalRef!: BsModalRef;
  idModal: any = '';
  sizeModal: any = '';
  titleModal: any = '';
  mostrarCalendario: boolean = true;
  agendamentoAtual!: {
    start: any;
    end: string;
    titulo: string;
    id: any;
    link: any;
  };
  diaSelecionado: any;
  horaInicio: any;
  horaFim: any;
  private readonly spinnerKey = 'videoconferencia';
  stepAtual!: number;
  propostaEnum = PropostaExternaEnum;
  propostaId!: string;
  listaDeBeneficiarios = new Array<any>();
  dataExpiraPropostaPortabilidade: any;
  temPortabilidade: boolean = false;
  corAlertaTipoJudicializacao = 'bg-info';

  constructor(
    public agendaService: AgendaService,
    private changeDetector: ChangeDetectorRef,
    private bsModalService: BsModalService,
    private _spinnerService: SpinnerService,
    private toastr: ToastrService,
    private _router: Router,
    private _activeRoute: ActivatedRoute,
    private _errorLoggingService: ErrorLoggingService,
    private moduloPermissoesService: ModuloPermissoesService,
    private _compartilharDadosEntreComponentsService: CompartilharDadosEntreComponentsService,
  ) {}

  ngOnInit(): void {
    this.receberDadosDoBeneficiario();
    this.temAgendamento();
  }

  sessaoVencida() {
    this.toastr.warning(this.mensagemSessao);
    this._router.navigate(['']);
  }

  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }

  async temAgendamento() {
    this.iniciarSpinner();
    this.propostaId = this._activeRoute.snapshot.paramMap.get('idProposta') || '';

    try {
      const data: any = await lastValueFrom(this.agendaService.buscarEventosPorProposta(this.propostaId));
      const ultimoEvento = data?.events[data.events.length - 1];
      this.stepAtual = ultimoEvento ? ultimoEvento.proposalStep : null;

      this.gerarSemana();
      if (!ultimoEvento) {
        this.mostrarCalendario = true;
        this.agendamentoAtual = null as any;
      } else {
        this.mostrarCalendario = false;
        this.agendamentoAtual = {
          start: ultimoEvento.start,
          end: ultimoEvento.end,
          titulo: ultimoEvento.title,
          link: ultimoEvento?.googleMeetUrl || null,
          id: ultimoEvento?.id,
        };
      }

      this.changeDetector.detectChanges();
    } catch (err) {
      this.toastr.error('Erro ao buscar agendamentos.');
      this.toastr.toastrConfig.preventDuplicates = true;
    } finally {
      await new Promise(r => setTimeout(r));
      this.pararSpinner();
    }
  }

  gerarSemana() {
    try {
      // this.iniciarSpinner();
      const hoje = new Date();
      const diaSemanaHoje = hoje.getDay(); // 0 (domingo) a 6 (sábado)

      const diferencaParaSegunda = (diaSemanaHoje + 6) % 7; // quantos dias voltar para chegar na segunda
      const segunda = new Date(hoje);
      segunda.setDate(hoje.getDate() - diferencaParaSegunda + this.semanaOffset * 7);

      this.listaSemana = [];

      for (let i = 0; i < 5; i++) {
        const data = new Date(segunda);
        data.setDate(segunda.getDate() + i);

        const dataStr = this.formatarDataCalendario(data);
        const isHoje = this.ehMesmaData(data, hoje);
        const isAmanha = this.ehMesmaData(data, new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() + 1));
        const desabilitado =
          this.semanaOffset === 0 && data < new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());

        let label = this.diasDaSemana[data.getDay()];
        if (isHoje) label = 'hoje';
        else if (isAmanha) label = 'amanhã';

        this.listaSemana.push({
          data: dataStr,
          diaSemana: label,
          desabilitado,
        });
      }

      const selecionavel = this.listaSemana.find(dia => !dia.desabilitado);
      if (selecionavel) {
        this.dataSelecionadaAtual = selecionavel.data;
      }

      this.dataSelecionada(this.dataSelecionadaAtual);
    } catch (error) {
    } finally {
      //  this.pararSpinner();
    }
  }

  selecionarData(data: string, desabilitado: boolean) {
    if (desabilitado) return;
    this.dataSelecionadaAtual = data;
  }

  ehMesmaData(d1: Date, d2: Date): boolean {
    return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
  }

  formatarDataCalendario(data: Date): string {
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    return `${dia}/${mes}`;
  }

  proximaSemana() {
    this.iniciarSpinner();
    this.semanaOffset++;
    this.gerarSemana();
    this.pararSpinner();
  }

  semanaAnterior() {
    if (this.semanaOffset > 0) {
      this.semanaOffset--;
      this.gerarSemana();
    }
  }

  buscarHorariosDisponiveisPorData(data: string) {
    this.iniciarSpinner();
    try {
      this.agendaService
        .buscarHorariosDisponeveis(data, data)
        .pipe(
          finalize(() => {
            this.pararSpinner();
          }),
        )
        .subscribe((response: any) => {
          const eventos = response.events || [];
          this.listaHorariosManha = [];
          this.listaHorariosTarde = [];
          const agora = new Date();
          const dataSelecionadaDate = new Date(`${data}T00:00:00`);

          eventos?.forEach((evento: any) => {
            const inicio = new Date(evento.start);
            const fim = new Date(evento.end);
            // Se o início do horário for anterior ao momento atual, pula
            if (inicio <= agora) return;
            const horario = {
              horainicio: this.formatarHora(inicio),
              horafim: this.formatarHora(fim),
            };

            if (inicio.getHours() < 12) {
              this.listaHorariosManha.push(horario);
            } else {
              this.listaHorariosTarde.push(horario);
            }
          });

          // Se for o dia atual e já passou do meio-dia, limpa a lista da manhã
          if (this.ehMesmaData(dataSelecionadaDate, new Date()) && new Date().getHours() >= 12) {
            this.listaHorariosManha = [];
          }
        });
    } catch (error) {}
  }

  private formatarHora(data: Date): string {
    const hora = data.getHours();
    const minuto = data.getMinutes();
    return `${this.padZero(hora)}:${this.padZero(minuto)}`;
  }

  dataSelecionada(data: any) {
    this.dataSelecionadaAtual = data;
    const dataFormatada = this.formatarDataParaBackend(data);
    this.diaSelecionado = dataFormatada;
    this.buscarHorariosDisponiveisPorData(dataFormatada);
  }

  private formatarDataParaBackend(data: string): string {
    if (!data) return '';

    const [dia, mes] = data.split('/').map(Number);
    const ano = new Date().getFullYear();
    const diaFormatado = this.padZero(dia);
    const mesFormatado = this.padZero(mes);

    return `${ano}-${mesFormatado}-${diaFormatado}`;
  }

  private padZero(valor: number): string {
    return valor < 10 ? '0' + valor : valor.toString();
  }

  private abrirModalAgendamento() {
    this.titleModal = 'Agendar Videoconferência ';
    this.sizeModal = 'modal-dialog modal-lg';
    this.idModal = 'dialogBeneficiario';
    this.modalRef = this.bsModalService.show(this.templateModalAgendarMeet, {
      class: 'modal-lg',
    });
  }

  agendarVideoConferencia(arg0: any, arg1: any) {
    this.horaInicio = arg0;
    this.horaFim = arg1;
    this.abrirModalAgendamento();
  }

  formatarDataParaExibir(diaOuEvento: string | {start: string; end?: string}): string {
    let dataReferencia: Date;
    let horaInicio: string;
    let horaFim: string;

    if (typeof diaOuEvento === 'string') {
      // Caso seja uma string no formato 'yyyy-MM-dd'
      const [ano, mes, dia] = diaOuEvento.split('-').map(Number);
      const data = new Date();
      data.setFullYear(ano, mes - 1, dia);
      data.setHours(0, 0, 0, 0);

      dataReferencia = data;
      horaInicio = this.horaInicio ?? '00:00';
      horaFim = this.horaFim ?? '00:30';
    } else {
      // Caso seja um objeto evento com start/end
      dataReferencia = new Date(diaOuEvento.start);

      horaInicio = dataReferencia.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
      });

      const horaFimDate = new Date(dataReferencia.getTime() + 30 * 60 * 1000);
      horaFim = horaFimDate.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
      });
    }

    const diaSemana = dataReferencia.toLocaleDateString('pt-BR', {
      weekday: 'long',
    });
    const dataFormatada = dataReferencia.toLocaleDateString('pt-BR');

    return `${diaSemana}, ${dataFormatada}, ${horaInicio} até ${horaFim}`;
  }

  async criarEventoVideoConferencia(diaEscolhido: any) {
    if (!this.podeCadastrarEditar && this.ehColaborador) {
      this.toastr.warning('Você não tem permissão para essa ação. Solicite essa permissão para seu supervisor.');
      this.toastr.toastrConfig.preventDuplicates = true;
      return;
    }

    this.iniciarSpinner();

    try {
      // Extrai a data/hora completa selecionada
      const dataHoraSelecionada = new Date(`${diaEscolhido}T${this.horaInicio}:00`);
      0;
      const agora = new Date();

      if (dataHoraSelecionada <= agora) {
        this.toastr.warning('Este horário já passou. Escolha outro horário disponível.');

        // Remover o horário da lista (manhã ou tarde)
        const removerDe = dataHoraSelecionada.getHours() < 12 ? this.listaHorariosManha : this.listaHorariosTarde;
        const index = removerDe.findIndex(h => h.horainicio === this.horaInicio && h.horafim === this.horaFim);
        if (index > -1) {
          removerDe.splice(index, 1);
        }
        this.fecharModal();
        return;
      }

      // Extrai a data de início do evento selecionado
      const dataFormatadaParaBack = `${diaEscolhido}T${this.horaInicio}:00`;
      const propostaId = this._activeRoute.snapshot.paramMap.get('idProposta') || '';
      const objVideo = {
        proposalId: propostaId,
        scheduledDateTimeUtc: dataFormatadaParaBack,
      };

      this.agendaService
        .agendarVideoConferencia(objVideo)
        .pipe(
          finalize(() => {
            this.pararSpinner();
          }),
        )
        .subscribe({
          next: async data => {
            this.toastr.success('Evento criado com sucesso.');
            this.toastr.toastrConfig.preventDuplicates = true;
            if (data.createdAppointment.status === 'Agendado') {
              this.mostrarCalendario = false;
              this.stepAtual = this.propostaEnum.VIDEO_CONFERENCIA;
              this.agendamentoAtual = {
                start: data.createdAppointment.scheduledDateTimeUtc,
                end: data.createdAppointment.scheduledDateTimeUtc + 30 * 60 * 1000,
                // Ajuste para adicionar 30 minutos
                // Exemplo: se o evento começa às 10:00, termina às 10:30
                titulo: data.createdAppointment.title || 'Videoconferência proposta',
                link: data.createdAppointment?.googleMeetUrl || null,
                id: data.createdAppointment?.googleCalendarEventId,
              };
            } else {
              this.mostrarCalendario = true;
              this.agendamentoAtual = null as any;
              this.toastr.warning('Evento não agendado.');
            }
            this.bsModalService.hide();
          },
          error: error => {
            // Extrai mensagem de erro aninhada
            let textoErro = 'Erro ao agendar evento.';
            const raw = error.message || error.error?.message;
            if (raw && raw.startsWith('{')) {
              try {
                const parsed = JSON.parse(raw);
                if (parsed.message) {
                  textoErro = parsed.message;
                }
              } catch {
                textoErro = raw;
              }
            } else if (typeof raw === 'string') {
              textoErro = raw;
            }
            this.toastr.error(textoErro);
            this.toastr.toastrConfig.preventDuplicates = true;
            this.pararSpinner();
          },
        });
    } catch (error: any) {
      const msg = error?.message || 'Erro inesperado ao agendar evento.';
      this.toastr.error(msg);
      this.toastr.toastrConfig.preventDuplicates = true;
    }
  }

  fecharModal() {
    this.pararSpinner();
    this.bsModalService.hide();
  }

  cancelarAgendamento() {
    this.fecharModal();
  }

  async onModalConfirmarDeleteEventoBeneficiario(evento: any) {
    this.titleModal = 'Cancelar Evento';
    this.sizeModal = 'modal-dialog';
    this.idModal = 'apagarEventoBeneficiario';
    this.modalRef = this.bsModalService.show(this.templateModalApagar);
  }

  async cancelarAgendamentoBeneficiario(idEvento: any) {
    if (!this.podeCadastrarEditar && this.ehColaborador) {
      this.toastr.warning('Você não tem permissão para essa ação. Solicite essa permissão para seu supervisor.');
      this.toastr.toastrConfig.preventDuplicates = true;
      return;
    }

    this.iniciarSpinner();
    try {
      await new Promise<void>((resolve, reject) => {
        this.agendaService
          .apagarEvento(idEvento, this.propostaId)
          .pipe(
            finalize(() => {
              this.pararSpinner();
            }),
          )
          .subscribe({
            next: () => {
              this.toastr.success('Evento cancelado com sucesso.');
              this.toastr.toastrConfig.preventDuplicates = true;
              resolve();
            },
            error: err => {
              this._errorLoggingService.logError('Erro ao cancelar um agendamento na videoconferência.', err, {
                contexto: 'Falha ao cancelar um agendamento na videoconferência.',
                idEvento: idEvento,
                propostaId: this.propostaId,
              });

              reject(err);
            },
          });
      });
      this.gerarSemana();
      this.fecharModal();
      this.mostrarCalendario = true;
      this.agendamentoAtual = null as any;
    } catch (error) {
      this.toastr.warning('Erro ao cancelar evento.');
      this.pararSpinner();
    }
  }

  public get ehColaborador(): boolean {
    return this._router.url.includes('colaborador');
  }

  get podeCadastrarEditar() {
    return this.moduloPermissoesService.permissaoCadastrarEditar(Modulo.CADASTROS, SubModuloNome.PROPOSTA_GESTAO_SAUDE);
  }

  receberDeclinio(stepDeclinado: number) {
    this.stepAtual = stepDeclinado || this.propostaEnum.PROPOSTA_DECLINADA;
  }

  async receberDadosDoBeneficiario(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._compartilharDadosEntreComponentsService.obterDadosCompartilhados().subscribe(
        async data => {
          try {
            const dadosBeneficiario = data[0]?.dadosBeneficiario;
            await this.separarBeneficiarios(dadosBeneficiario);
            this.dataExpiraPropostaPortabilidade = dadosBeneficiario.expireIn;

            this.temPortabilidade = this.listaDeBeneficiarios.some(
              item => item.proposalType == TipoPropostaEnum.PORTABILIDADE,
            );

            resolve(true);
          } catch (error) {
            reject(error);
          }
        },
        error => {
          reject(error);
        },
      );
    });
  }

  async separarBeneficiarios(dados: any) {
    const beneficiario = dados && dados.holderProposal;

    if (beneficiario) {
      const dadosTitular = {...beneficiario};
      delete dadosTitular.dependentsProposal;

      this.listaDeBeneficiarios.push({
        ...dadosTitular,
        isDependent: false,
        proposalType: dados.proposalType,
      });

      if (beneficiario.dependentsProposal && Array.isArray(beneficiario.dependentsProposal)) {
        beneficiario.dependentsProposal.forEach((dependente: any) => {
          const itemDependente = {
            ...dependente,
            isDependent: true,
          };
          this.listaDeBeneficiarios.push(itemDependente);
        });
      }
    }
  }
}
